import { AvField, AvForm } from 'availity-reactstrap-validation'
import { primary_color } from '../../../Helper/uiHelper'
import { Button } from 'reactstrap'
import { request } from '../../../Redux/Sagas/requests/api'
import { isSuccessResponse } from '../../../helper'
import { useSelector } from 'react-redux'

const RaiseForm = ({
  formFieldValue,
  onSuccess,
  selectedBooking,
  bookingConsentSelected,
  queryFormHeading,
  queryFormsubHeading,
  setCreatedTicketId,
}) => {
  const publicUser = useSelector((state) => state.User?.publicUser)
  const onSubmitForm = (values) => {
    request('raise-ticket/ticket/create', 'POST', {
      ...values,
      query_type_id: formFieldValue?.query_type_id,
      query_id: formFieldValue?.query_id,
      user_id: publicUser?.id,
      booking_reservation_id: selectedBooking,
    }).then((res) => {
      if (isSuccessResponse(res, 'Ticket raised!')) {
        onSuccess()
        setCreatedTicketId(res?.data?.data?.id)
      }
    })
  }
  return (
    <div>
      <div className='h2 font-weight-bold mb-4  ' style={{ color: primary_color }}>
        {queryFormHeading?.replace(/<[^>]*>/g, '') ||
          " Feel free to reach out and leave us a message, we're here to help and solve any questions you may have."}
      </div>
      {!bookingConsentSelected && (
        <div className='p text-muted' style={{ fontWeight: '100' }}>
          {queryFormsubHeading?.replace(/<[^>]*>/g, '') ||
            'As you have not selected you wish to query a booking, this ticket cannot be used due to GPDR to discuss any booking.'}
        </div>
      )}
      <AvForm onValidSubmit={(e, values) => onSubmitForm(values)} className='mt-5'>
        <AvField type='text' placeholder='subject' name='subject' className='subtitle1' required></AvField>
        <AvField type='textarea' placeholder='message' name='message' className='subtitle1' required></AvField>
        <Button style={{ borderRadius: '50rem', background: primary_color, width: '100%' }} className='mt-2 subtitle1 py-3'>
          Send
        </Button>
      </AvForm>
    </div>
  )
}

export default RaiseForm
